var lists_default = {
  "fontElementMap": "qnH-q",
  "orderedlist": "t-JRg",
  "bulletedlist": "RXGwu",
  "listItem": "sXSIP"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
